import { useMemo, useState, useEffect } from "react";
import { HS_CODE_OPTIONS } from "../../../constants/variable";

type Option = { label: string; value: string };

interface HsCodeInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export default function HsCodeInput({
  value,
  onChange,
  placeholder = "Type to search HS code...",
  className,
}: HsCodeInputProps) {
  const [query, setQuery] = useState(value || "");

  useEffect(() => {
    setQuery(value || "");
  }, [value]);

  const filteredOptions = useMemo(() => {
    if (!query.trim()) return [];
    return HS_CODE_OPTIONS.filter(
      (opt) =>
        opt.label.toLowerCase().includes(query.toLowerCase()) ||
        opt.value.toLowerCase().includes(query.toLowerCase())
    );
  }, [query]);

  const handleSelect = (opt: Option) => {
    onChange(`${opt.value} - ${opt.label}`); // send value back to form
    setQuery(`${opt.value} - ${opt.label}`); // show nicely in input
  };

  return (
    <div className="relative">
      <input
        type="search"
        value={query}
        placeholder={placeholder}
        className={className ? className : "input-new"}
        onChange={(e) => setQuery(e.target.value)}
        onBlur={() => {
          if (!filteredOptions.some((opt) => opt.value === query)) {
            onChange(query);
          }
        }}
      />

      {filteredOptions.length > 0 && (
        <ul className="absolute mt-1 max-w-60 w-max bg-white border rounded shadow-lg max-h-52 overflow-auto z-10">
          {filteredOptions.map((opt) => (
            <li
              key={opt.value}
              className="px-3 py-2 text-sm hover:bg-blue-50 cursor-pointer"
              onClick={() => handleSelect(opt)}
            >
              <span className="font-medium text-gray-800">{opt.value}</span>{" "}
              <span className="text-gray-500">— {opt.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
